import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> Ticket form configuration (v4/api, `App\Settings\
 * Easeedesk\EaseedeskFormConfiguration`). Forma paginii e inghetata in
 * `settings/easeedesk/__fixtures__/ticketFormConfiguration.json`.
 */
export interface FormConfigurationStatus {
  ID: number
  status_name: string
  form_id: number
}

export interface FormConfigurationType {
  ID: number
  type_name: string
  short_name: string
  color_identifier: string
  workflow_id: number
  statuses: FormConfigurationStatus[]
}

export interface FormConfigurationPage {
  form_list: { ID: number; form_name: string }[]
  type_entities: FormConfigurationType[]
}

export function formConfigurationQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_form_configuration'],
    queryFn: () => apiGet<FormConfigurationPage>('/settings/easeedesk/ticket_form_configuration'),
  })
}

/** `Easeedesk::assign_form_status` - `ticket_type`, `ticket_status`, `form_id`. */
export function assignFormStatus(ticketType: number, ticketStatus: number, formId: string) {
  return apiPost<{ status: string }>('/settings/easeedesk/ticket_form_configuration/assign', {
    ticket_type: String(ticketType),
    ticket_status: String(ticketStatus),
    form_id: formId,
  })
}
